module.exports = __webpack_public_path__ + "img/logo.41da9cdb.png";